export default __webpack_public_path__ + "static/media/success-svgrepo-com.a7e9a3da.svg";